"use strict";
exports.__esModule = true;
exports.chart_bullet_Height = {
  "name": "--pf-chart-bullet--Height",
  "value": 140,
  "var": "var(--pf-chart-bullet--Height, 140)"
};
exports["default"] = exports.chart_bullet_Height;